var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['pt-sub-title']},[_c('div',{class:_vm.$style['sub-title-content']},[_c('div',{class:_vm.$style['sub-title-text']},[_vm._v(_vm._s(_vm.title)+"\n          "),_vm._t("line")],2),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }